import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectRouteStorageService {
  private readonly REDIRECT_ROUTE_KEY = 'redirect_route';

  get() {
    const route = localStorage.getItem(this.REDIRECT_ROUTE_KEY);
    return route ?? null;
  }

  set(route: string) {
    localStorage.setItem(this.REDIRECT_ROUTE_KEY, route);
  }

  clear() {
    localStorage.removeItem(this.REDIRECT_ROUTE_KEY);
  }
}
